interface CompanyInterface {
    id: number;
    name: string;
    manager: string;
    description: string;
}

class Company implements CompanyInterface {
    id: number;
    name: string;
    manager: string;
    description: string;
}

export {
    Company
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/companies/api.models.ts